module.exports = __webpack_public_path__ + "img/dc1bb17.jpg";